import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'employerPhoneNumber',
    label: 'Phone Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'employerPhoneSource',
    label: 'Employer Phone Source',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'otherEmployerPhoneSourceDescription',
    label: 'Other Employer Phone Source Description',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'employerVerifierName',
    label: 'Employer Verifier Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'employerVerifierTitle',
    label: 'Employer Verifier Title',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'verificationMethod',
    label: 'Verification Method',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'employedAtTimeOfVerification',
    label: 'Employed at Time of Verification?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'probabilityOfContinuedEmployment',
    label: 'Probability of Continued Employment?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'onTemporaryLeave',
    label: 'On Temporary Leave?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'businessExistenceVerified',
    label: 'Business Existence Verified?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'businessVerificationMethod',
    label: 'Business Verification Method',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'position',
    label: 'Position',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'hireDate',
    label: 'Hire Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'verifierFullName',
    label: 'Verifier Full Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'verifierTitle',
    label: 'Verifier Title',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'verifierCompanyName',
    label: 'Verifier Company Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'dateCompleted',
    label: 'Date Completed',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'comments',
    label: 'Comments',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const voeIncomeForm = {
  name: FormNames.EMPLOYMENT_VERIFICATION,
  label: 'Employment Verification',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
